import { gql } from '@apollo/client';

export const TestTypeFormatContent = gql`
  fragment TestTypeFormatContent on TestTypeFormatContent {
    title
    description
    promotionLabel
  }
`;
